import CodeInput from '../../../components-v0/PhoneValidationDrawer/components/CodeInput/CodeInput'
import { SignUpValidationType } from '../contracts'

export const SignUpValidation = ({
  handleNext,
}: SignUpValidationType): JSX.Element => <CodeInput handleNext={handleNext} />
